import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63f13a82")

_pushScopeId("data-v-63f13a82")
const _hoisted_1 = { class: "esd-logo" }
const _hoisted_2 = { ref: "esdLogo" }
const _hoisted_3 = { class: "not-found-div" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "Possible causes may be an invalid URL or needing connection to VPN", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, null, 512)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("h2", null, "\"" + _toDisplayString(_ctx.requestedApp) + "\" Not Found(External)", 1),
      _hoisted_4
    ])
  ]))
})